import {
    QueryKey,
    UseQueryOptions,
    UseQueryResult,
    useQuery,
} from "react-query";

import { IExternalListPage } from "../../types";
import { InstaMart, IInstaMartResult } from "../../utils/api";
import { useAuth } from "../useAuth";

type TUseQueryOptions<
    TQueryFnData,
    TError,
    TData,
    TQueryKey extends QueryKey,
> = Omit<UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>, "queryFn">;

export interface IUseGetInstaMartResultsParameters {
    cursor?: string;
    direction?: string;
    limit: number;
    skuId?: string;
    pincode?: string;
    startDate?: string;
    endDate?: string;
    options?: TUseQueryOptions<
        any,
        unknown,
        IExternalListPage<IInstaMartResult>,
        string[]
    >;
}

export const useGetInstaMartResults = (
    parameters: IUseGetInstaMartResultsParameters,
): UseQueryResult<IExternalListPage<IInstaMartResult>, unknown> => {
    const {
        options,
        cursor,
        direction,
        limit,
        skuId,
        pincode,
        startDate,
        endDate,
    } = parameters;

    const { token } = useAuth();

    if (!token) {
        throw new Error(
            "Cannot fetch InstaMArt results without authentication token",
        );
    }

    return useQuery({
        queryKey: options?.queryKey ?? [],
        queryFn: async () => {
            const response = await InstaMart.getResults({
                direction,
                limit,
                cursor,
                skuId,
                pincode,
                startDate,
                endDate,
                token,
            });

            return response;
        },
        ...options,
    });
};
